import React from 'react';
import { graphql } from 'gatsby';
import IndexPage from 'components/pages/IndexPage';

const seo = {
  title: 'Q°emotion – Emotional & Semantic analysis of Customer Reviews',
  keywords: [
    'Emotional analysis',
    'AI',
    'SaaS solution',
    'Q emotion',
    'Customer review',
    'Customer feedback',
    'Feedbacks',
    'Verbatim',
  ],
  description:
    'How do your customers feel about your brand?\n' +
    'Find out how AI and emotion analysis helps you analyze your feedback to get the job done.',
};

export default props => <IndexPage {...props} seo={seo} />;

export const pageQuery = graphql`
  query {
    dataBlockIntro: markdownRemark(
      frontmatter: {
        pageType: { eq: "indexPage" }
        blockType: { eq: "introBlock" }
        lang: { eq: "en" }
      }
    ) {
      rawMarkdownBody
      frontmatter {
        title
      }
    }
    dataBlockSubintro: markdownRemark(
      frontmatter: {
        pageType: { eq: "indexPage" }
        blockType: { eq: "subintroBlock" }
        lang: { eq: "en" }
      }
    ) {
      rawMarkdownBody
      frontmatter {
        subTitle
      }
    }
    imageSubintroBlock: allFile(
      filter: {
        relativeDirectory: { eq: "indexPage/subIntroBlock/blockImage" }
      }
      sort: { fields: [base] }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
    dataImageMinLeftSubintro: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "subintroBlock" }
          component: { eq: "imageMinLeft" }
        }
      }
      sort: { fields: [frontmatter___relatedImage] }
    ) {
      nodes {
        frontmatter {
          relatedImage
        }
      }
    }
    dataImageMinRightSubintro: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "subintroBlock" }
          component: { eq: "imageMinRight" }
        }
      }
      sort: { fields: [frontmatter___relatedImage] }
    ) {
      nodes {
        frontmatter {
          relatedImage
        }
      }
    }
    dataTestimonialBlock: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "solutionMarketing" }
          blockType: { eq: "testimonialBlock" }
          lang: { eq: "en" }
        }
      }
      sort: { order: ASC, fields: [frontmatter___order] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          author
          role
          image
          youtubeID
          youtubeTitle
        }
      }
    }
    imageTestimonialBlock: allFile(
      filter: { relativeDirectory: { eq: "bubbleImages" }, base: { in: [] } }
      sort: { fields: [id], order: [ASC] }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            presentationWidth
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
    imagesQuotesTestimonialBlock: allFile(
      filter: {
        relativeDirectory: {
          eq: "solutionPage/analyseVerbatim/testimonialBlock"
        }
      }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
    imageMinSubintroBlock: allFile(
      filter: {
        relativeDirectory: { eq: "indexPage/subIntroBlock/blockImage/minImage" }
      }
      sort: { fields: [base] }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 100, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
    imageClientSubintroBlock: allFile(
      filter: {
        relativeDirectory: { eq: "indexPage/subIntroBlock/blockClients" }
      }
      sort: { fields: [base] }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 120, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
    dataBlockActionBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "actionBlock" }
          lang: { eq: "en" }
          component: { eq: "block" }
        }
      }
      sort: { fields: [frontmatter___numBlockAction] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          numBlockAction
          component
        }
      }
    }
    dataBlockActionTitle: markdownRemark(
      frontmatter: {
        pageType: { eq: "indexPage" }
        blockType: { eq: "actionBlock" }
        lang: { eq: "en" }
        component: { eq: "title" }
      }
    ) {
      rawMarkdownBody
    }
    imageActionBlock: file(
      relativeDirectory: { eq: "indexPage/actionBlock/en" }
    ) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
          presentationWidth
        }
      }
    }
    dataBlockOperationTitle: markdownRemark(
      frontmatter: {
        pageType: { eq: "indexPage" }
        blockType: { eq: "operationBlock" }
        lang: { eq: "en" }
        component: { eq: "title" }
      }
    ) {
      rawMarkdownBody
    }
    dataBlockOperationBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "operationBlock" }
          lang: { eq: "en" }
          component: { eq: "subTitle" }
        }
      }
      sort: { fields: [frontmatter___numBlockOperation] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          numBlockOperation
          relatedImage
        }
      }
    }
    imageOperationBlock: allFile(
      filter: { relativeDirectory: { eq: "indexPage/operationBlock/en" } }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
    dataBlockLinkBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "linkBlock" }
          lang: { eq: "en" }
        }
      }
      sort: { fields: [frontmatter___idBlock] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          subTitle
          color
          link
          buttonText
        }
      }
    }
    dataBlockVideoTitle: markdownRemark(
      frontmatter: {
        pageType: { eq: "indexPage" }
        blockType: { eq: "videoBlock" }
        lang: { eq: "en" }
        component: { eq: "title" }
      }
    ) {
      rawMarkdownBody
    }
    dataBlockVideoBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "indexPage" }
          blockType: { eq: "videoBlock" }
          lang: { eq: "en" }
          component: { eq: "slide" }
        }
      }
      sort: { fields: [frontmatter___numSlide] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          numSlide
          relatedImage
          link
        }
      }
    }
    imageVideoBlock: allFile(
      filter: { relativeDirectory: { eq: "indexPage/videoBlock/slides" } }
    ) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 150, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
            presentationWidth
          }
        }
      }
    }
  }
`;
